import React from 'react';
import { useSelector } from 'react-redux';

import {
  WrapperFlex,
  Collapse,
  CollapseHeader,
  CollapseContent,
} from '@unimed-fesp/components';

// import {
//   Collapse,
//   CollapseHeader,
//   CollapseContent,
// } from '../../molecules/Collapse';
// TO-DO trocar por componente da lib
import Input from '../../atoms/Input';
// TO-DO trocar pelo TextArea da lib
import TextArea from '../../atoms/TextArea';
// TO-DO trocar por button da lib
import ButtonRemove from '../../atoms/ButtonRemove';

import UploadBox from '../../molecules/UploadBox';
import LabelContainer from '../../molecules/LabelContainer';

import useMovimentacao from '../../../hooks/useMovimentacao';

import { MovimentacaoListaEnum } from '../../../enums';

import { UploadFileLoading } from './styles';

function CollapseListaDetalhe({
  file,
  loading,
  uploadSuccess,
  onClickHandleCancelList,
  acao,
  handleFiles,
}) {
  const MAX_QUANT_FILES = 1;
  const { setValidacao, setErrors } = useMovimentacao();

  const { usuario } = useSelector((state) => state.auth);

  return (
    <Collapse>
      <CollapseHeader flex justifySpaceBetween alignCenter fullWidth>
        <WrapperFlex
          justifySpaceBetween
          alignCenter
          padding="15"
          fullWidth
          marginLeft={10}
        >
          {file.name}
          <ButtonRemove onClick={() => onClickHandleCancelList(file)} />
        </WrapperFlex>
      </CollapseHeader>
      <WrapperFlex flexWrap justifyStart alignStart>
        <CollapseContent justifyContent="start" alignItems="start">
          <WrapperFlex
            flexWrap
            justifySpaceBetween
            alignStart
            marginBottom={25}
          >
            <LabelContainer text="Lista">
              <Input width="164" height="40" value={file.nomeLista} disabled />
            </LabelContainer>
            <LabelContainer text="Contratante">
              <Input
                width="400"
                height="40"
                value={`${file.codigoContratante} - ${usuario.nomeEmpresa}`}
                disabled
              />
            </LabelContainer>
          </WrapperFlex>
          <WrapperFlex marginBottom={25}>
            <LabelContainer text="Descrição(opcional)">
              <TextArea
                name={`descricao[${file.idLista}]`}
                width="682px"
                height="83px"
              />
            </LabelContainer>
          </WrapperFlex>
          {acao !== MovimentacaoListaEnum.returnIdForName.Transferencia ? (
            <WrapperFlex justifySpaceEvenly alignCenter marginBottom={25}>
              <WrapperFlex column flexStart marginBottom={25}>
                <LabelContainer onClick={() => {}} text="Arquivo" />
                <UploadBox
                  uploadSuccess={uploadSuccess}
                  loading={loading}
                  file={file}
                  maxQuantityFiles={MAX_QUANT_FILES}
                  maxSizeFiles={setValidacao(acao).maxSizeFiles}
                  validExtension={setValidacao(acao).validExtension}
                  applyValidation
                  invalidCallback={setErrors(acao)}
                  setFiles={handleFiles}
                />
              </WrapperFlex>
              <UploadFileLoading isLoading={loading} />
            </WrapperFlex>
          ) : null}
        </CollapseContent>
      </WrapperFlex>
    </Collapse>
  );
}

export default CollapseListaDetalhe;
